import {Col, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {deleteEmployee, getMyCompanyEmployees, saveEmployee} from "../common/api/WebApi";
import {Card, Chip, Link} from "@mui/material";
import ManageEmployeeModal from "../employee/ManageEmployee";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import MDButton from "../../components/MDButton";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Icon from "@mui/material/Icon";
import {useNavigate} from "react-router-dom";
import Confirm from "../common/Confirm";

export default function Employees(props) {
  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);

  const [saving, setSaving] = useState(false);
  const [manageEmployee, setManageEmployee] = useState(false);
  const [employee, setEmployee] = useState();
  const [employees, setEmployees] = useState([]);
  const [refreshEmployees, setRefreshEmployees] = useState(false);

  const getEmployeesFn = ()=> {
    getCompanyEmployeesFn().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEmployees(result);
      }
    });
  }
  useEffect(() => {
    getEmployeesFn();
  }, []);

  const [confirmation, setConfirmation] = useState(null);
  const [confirmDeleteEmployee, setConfirmDeleteEmployee] = useState(false);

  const preDeleteEmployeeFn = (employee) => {
    let confirmation = {
      title: 'Delete ' + employee.firstName + '?',
      message: 'Delete ' + employee.firstName + ' ' + employee.lastName + ' Permanently?',
      entity: employee
    }
    setConfirmation(confirmation);
    setConfirmDeleteEmployee(true);
  };

  useEffect(()=> {
    if (refreshEmployees) {
      setRefreshEmployees(false);
      getEmployeesFn();
    }
  },[refreshEmployees]);

  const handleConfirmDeleteEmployee = async (employee) => {
    setSaving(true);
    setConfirmDeleteEmployee(false);
    let result = await deleteEmployee(employee);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshEmployees(true);
      setConfirmDeleteEmployee(false);
    }
  }

  const getCompanyEmployeesFn = async () => {
    return await getMyCompanyEmployees();
  }

  const handleCloseEmployee = () => {
    setEmployee(null);
    setManageEmployee(false);
  };

  const handleSaveEmployee = async (employee) => {
    setSaving(true);

    let result = await saveEmployee(employee);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setManageEmployee(false);
      getCompanyEmployeesFn().then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setEmployees(result);
        }
      });
    }
  };

  const startManageEmployeeFn = (e) => {
    if (!e.guid) {
      e.newEmployee = true;
    }
    setEmployee(e);
    setManageEmployee(true);
  };

  const myRefs = useRef([]);
  const [renderIndex, setRenderIndex] = useState(1);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };
  return (
    <DashboardLayout>

      <Meta pageTitle={'Employees'}/>

      <ContextSearchNavbar title={'Employees'}/>
      <MDBox py={3}>
        <Card>
          <MDBox p={3}>
            <h5 className={'mb-3'}>
              &nbsp;
              <MDButton
                onClick={(e) => {
                  setManageEmployee(true);
                  startManageEmployeeFn({});
                }}
                color="secondary"
                size="small"
                className={'pull-right'}>
                Add Employee</MDButton>
            </h5>
            <ul className={'list-group'}>
              {employees?.length > 0 && employees?.map((employee, index) => {
                  return (
                    <li
                      className={'list-group-item hover-shadow'}
                      key={index}>
                      <Row>
                        <Col sm={12}>
                          <Link href={'/company/employees/view/' + employee.guid}>
                            {employee.backgroundColor && <span style={{
                              background: employee.backgroundColor,
                              width: '15px',
                              height: '15px',
                              float: 'left',
                              margin: '4px 6px 2px 0'
                            }}>
                                  </span>}
                            {employee.firstName} {employee.lastName}
                          </Link>
                          &nbsp;
                          {employee.companyAdmin && <Chip
                            variant={"outlined"}
                            label={"Company Admin"}/>
                          }
                          <div className={'pull-right px-2'}
                               onClick={(e) => {
                                 refHandler('employees' + index)
                               }}
                               ref={el => (myRefs.current['employees' + index] = el)}>

                            <MDButton
                              variant="outlined"
                              color="secondary"
                              size="small"
                              circular
                              iconOnly
                            >
                              <Icon>more_horiz</Icon>
                            </MDButton>

                            {renderIndex && myRefs.current['employees' + index]?.visible &&
                              <Menu open={true} anchorReference={null}
                                    anchorEl={myRefs.current['employees' + index]}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}>
                                <NotificationItem
                                  onClick={(e) => {
                                    navigate('/company/employees/view/' + employee.guid);
                                  }} icon={<Icon>person</Icon>} title="View"/>
                                <NotificationItem
                                  onClick={(e) => {
                                    startManageEmployeeFn(employee)
                                  }} icon={<Icon>edit</Icon>} title="Edit"/>
                                <NotificationItem onClick={(e) => {
                                  preDeleteEmployeeFn(employee)
                                }} icon={<Icon>delete</Icon>} title="Delete"/>
                              </Menu>
                            }
                          </div>
                        </Col>

                      </Row>
                    </li>
                  )
                }
              )}
            </ul>
          </MDBox>
        </Card>
      </MDBox>
      {
        <>

          {employee && <ManageEmployeeModal
            employee={employee}
            show={manageEmployee}
            saving={saving}
            handleSaveEmployee={handleSaveEmployee}
            handleClose={handleCloseEmployee}/>
          }

        </>
      }

      {
        confirmation && <Confirm confirmation={confirmation}
                                 show={confirmDeleteEmployee}
                                 saving={saving}
                                 handleConfirm={handleConfirmDeleteEmployee}
                                 handleSave={()=>{
                                   setConfirmation(null);
                                   setConfirmDeleteEmployee(false);
                                   setEmployee(null);
                                 }}/>
      }



      <Footer mt={5}/>

    </DashboardLayout>
  );
}